import { render, staticRenderFns } from "./CourierDetailPopup.vue?vue&type=template&id=eaf715e8&scoped=true"
import script from "./CourierDetailPopup.vue?vue&type=script&lang=js"
export * from "./CourierDetailPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf715e8",
  null
  
)

export default component.exports